// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';

import StepperContainer from '../../world/data/events/eventTile/StepperContainer';
import EventDetails from '../../world/data/events/eventTile/EventDetails';
import { getCurrentPcId } from '../../../utils/urlUtils';
import type { EventTileWithOpeningStore } from '../../../types/eventType';
import Loader from '../../common/Loader';

type State = {
  openingEvent: EventTileWithOpeningStore,
  isLoading: boolean,
}

class MallEvents extends React.Component<Props, State> {
  state: State = {
    openingEvent: null,
    isLoading: false,
  }

  updateClickedOpeningEvent = (openingEvent: EventTileWithOpeningStore) => {
    this.setState({ openingEvent });
  }

  updateIsLoading = (bool: boolean) => {
    this.setState({ isLoading: bool });
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="event-page mall-events-page">
        <div className="mall-events-container">
          <div className={`timeline${isLoading ? '--loading' : ''}`}>
            <StepperContainer
              pcId={getCurrentPcId()}
              isMallBase
              updateClickedOpeningEvent={this.updateClickedOpeningEvent}
              updateIsLoading={this.updateIsLoading}
            />
          </div>
          {
            isLoading
              ? (<Loader isLoading={isLoading} />)
              : (
                <div className="event-content">
                  <EventDetails openingEvent={this.state.openingEvent} />
                </div>
              )
          }
        </div>
      </div>
    );
  }
}

export default MallEvents;
